export const ProductCatalogType = {
  category: $localize`Category`,
  collection: $localize`Collection`,
};
